import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import { checkRolePermission } from "../../libs/checkPermission";
import TabBar from '../TabBar';
import QCRuleList from './QCRuleList';
import QCRuleModify from './QCRuleModify';
import ParameterQCList from './ParameterQC/ParameterQCList';
import ParameterQCModify from './ParameterQC/ParameterQCModify';
import QCFlagModify from './QCFlags/QCFlagModify';
import QCFlagList from './QCFlags/QCFlagList';

const QCHome = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          { label: 'Rules', to: `/qc/rule` },
          { label: 'Check', to: `/qc/check` },
          { label: 'Flag', to: `/qc/flag` },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};

export const QCRoutes = () => (
  <Route component={QCHome}>
    <IndexRedirect to='rule' />
    <Route path="rule" component={checkRolePermission(QCRuleList)} name="view qc-rule" >
      <Route path=":id" component={checkRolePermission(QCRuleModify)} name="modify qc-rule" />
    </Route>
    <Route path='check' component={ParameterQCList}>
      <Route path=':id' component={ParameterQCModify} />
    </Route>
    <Route path='flag' component={QCFlagList}>
      <Route path=':id' component={QCFlagModify} />
    </Route>
  </Route>

);


// WEBPACK FOOTER //
// ./src/components/QCRule/routes.js